import { render, staticRenderFns } from "./tradeGameRecord.vue?vue&type=template&id=1ef91efe&scoped=true"
import script from "./tradeGameRecord.vue?vue&type=script&lang=js"
export * from "./tradeGameRecord.vue?vue&type=script&lang=js"
import style0 from "./tradeGameRecord.vue?vue&type=style&index=0&id=1ef91efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef91efe",
  null
  
)

export default component.exports